import { z } from "zod";

export const capabilityReadinessActionKindSchema = z.enum([
  "connect_gmail",
  "open_shop_prerequisite",
  "open_products",
  "retry_probe",
]);

export const capabilityReadinessItemSchema = z
  .object({
    actions: z.array(
      z
        .object({
          kind: capabilityReadinessActionKindSchema,
          label: z.string().min(1).max(80),
        })
        .strict(),
    ),
    blocking_codes: z.array(z.string().regex(/^[a-z0-9][a-z0-9_.-]{0,119}$/u)),
    capability_key: z.string().min(1).max(160),
    observed_at: z.string().datetime({ offset: true }),
    provider: z.string().regex(/^[a-z][a-z0-9_]{0,79}$/u),
    request_id: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,159}$/u),
    resource_type: z.enum(["email_account", "shop"]),
    retryable: z.boolean(),
    shop_binding_id: z.string(),
    state: z.enum([
      "ready",
      "action_required",
      "unavailable",
      "degraded",
      "unknown",
    ]),
  })
  .strict();

export const capabilityReadinessResponseSchema = z
  .object({
    items: z.array(capabilityReadinessItemSchema),
    organization_id: z.string().min(1),
    schema_version: z.literal(1),
    scope_version: z.string().regex(/^sha256:[0-9a-f]{64}$/u),
  })
  .strict();

export const capabilityReadinessProbeResponseSchema = z
  .object({
    request_id: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,159}$/u),
    status: z.literal("queued"),
  })
  .strict();

export type CapabilityReadinessAction = z.infer<
  typeof capabilityReadinessActionKindSchema
>;
export type CapabilityReadinessItem = z.infer<
  typeof capabilityReadinessItemSchema
>;
export type CapabilityReadinessResponse = z.infer<
  typeof capabilityReadinessResponseSchema
>;
